<ng-container *ngIf="isAscending; else descending">
    <span class="sort-indicator">&#9650;</span>
</ng-container>
<ng-template #descending>
    <span class="sort-indicator">&#9660;</span>
</ng-template>